import React, { useState } from "react";
import "./menu.css";

export default function Menu({ user, item, setItem, filter, setFilter }) {
  const [options, setOptions] = useState(false);
  const [f, setF] = useState(filter);
  return (
    <div className="menu">
      <div className="left-menu">
        <div>Projects</div>
        <div className="filter-box">
          <div
            className="project-filter"
            onClick={() => {
              setOptions(!options);
            }}
          >
            {f}
          </div>
          {options && (
            <div className="project-filter-options">
              {user.filters.map((item, index) => (
                <div
                  className="project-filter-option"
                  onClick={() => {
                    setFilter(item.cat_name);
                    setF(item.filter_name);
                    setOptions(false);
                  }}
                >
                  {item.filter_name}
                </div>
              ))}
            </div>
          )}
          <label htmlFor="project-filter" className="filter-icon">
            <i class="fa-solid fa-filter"></i>
          </label>
        </div>
      </div>
      <div className="right-menu">
        <div
          className={
            item === 2
              ? "top-menu-item top-menu-item-selected"
              : "top-menu-item"
          }
          onClick={() => {
            setItem(2);
          }}
        >
          Experience
        </div>
        <div
          className={
            item === 3
              ? "top-menu-item top-menu-item-selected"
              : "top-menu-item"
          }
          onClick={() => {
            setItem(3);
          }}
        >
          Education
        </div>
        <div
          className={
            item === 1
              ? "top-menu-item top-menu-item-selected"
              : "top-menu-item"
          }
          onClick={() => {
            setItem(1);
          }}
        >
          Skills
        </div>
      </div>
    </div>
  );
}
